// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__7M1ma","customCheckbox":"Checkbox_customCheckbox__6y3pp"};